import React from "react";
import {
  FaChartLine,
  FaHandHoldingUsd,
  FaExchangeAlt,
  FaCoins,
  FaBuilding,
} from "react-icons/fa";

function WhyBuild() {
  const reasons = [
    {
      icon: <FaChartLine size={32} />,
      title: "Growing Crypto Market Cap (3.2tn+)",
      desc: "The global cryptocurrency market continues to expand, offering massive revenue potential for exchange operators.",
    },
    {
      icon: <FaHandHoldingUsd size={32} />,
      title: "Earn Revenue in Crypto Fee/Charges",
      desc: "Generate consistent income through trading fees, listing fees, withdrawal charges, and premium services.",
    },
    {
      icon: <FaExchangeAlt size={32} />,
      title: "Crypto Exchange Leverage",
      desc: "Offer leveraged trading options to attract professional traders and increase your platform's trading volume.",
    },
    {
      icon: <FaCoins size={32} />,
      title: "Initial Crypto to Fiat Currency Setup",
      desc: "Create seamless fiat on-ramp and off-ramp gateways that make your exchange accessible to beginners.",
    },
    {
      icon: <FaBuilding size={32} />,
      title: "Institutional Adoption",
      desc: "Institutional investors are increasingly entering crypto markets, demanding robust and regulatory-compliant exchanges.",
    },
  ];

  return (
    <div style={{ padding: "80px 0", background: "#fff" }}>
      <div className="container">
        <div className="text-center mb-5">
          <h2
            className="fw-bold"
            style={{ color: "#0a1f44", fontSize: "clamp(24px, 3vw, 38px)" }}
          >
            Why build your own crypto exchange?
          </h2>
          <p
            className="text-muted mx-auto"
            style={{ maxWidth: "700px", fontSize: "16px" }}
          >
            The crypto market has grown exponentially, and building your own
            exchange puts you at the center of a trillion-dollar industry.
          </p>
        </div>
        <div className="row g-4 justify-content-center">
          {reasons.map((item, idx) => (
            <div className="col-lg-4 col-md-6" key={idx}>
              <div className="ce-why-card">
                <div className="ce-why-icon d-flex align-items-center justify-content-center">
                  {item.icon}
                </div>
                <div>
                  <h5
                    className="fw-bold mb-2"
                    style={{ color: "#0a1f44", fontSize: "17px" }}
                  >
                    {item.title}
                  </h5>
                  <p
                    className="mb-0 text-muted"
                    style={{ fontSize: "14px", lineHeight: "1.6" }}
                  >
                    {item.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default WhyBuild;
